import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayFromLength',
})
export class ArrayFromLengthPipe implements PipeTransform {
  transform(number: number | null | undefined): number[] {
    if (number === null || number === undefined || number < 1) return [];
    return Array.from({ length: number }).map((x, i) => i);
  }
}
